import React from 'react';
import { LoginModal } from './LoginModal';

export const DeveloperLoginPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-dark-bg-primary flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <LoginModal
          isOpen={true}
          onClose={() => {
            // Navigate back to landing page when closed
            window.location.href = '/';
          }}
          role="developer"
        />
      </div>
    </div>
  );
};